module.exports = __webpack_public_path__ + "static/media/demo_sneakymercury.65d627f4.PNG";